<template>
 
    <NavView></NavView>
    <SideBar></SideBar>
    {{this.my}}

    <div class="container-fluid">
        <!-- <h6 class=" font1 font-bold1 colr1 ">Create Customer</h6> -->
        <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/miinventory/index"> Manage Vehicle Inventory </router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create  </h6>



    
        <div class="card font1 ">
            <div class="card-body font1">

                <Form @submit="saveData()" class=" g-3"  :validation-schema="schema" v-slot="{ errors }" >
                    <div class="row ">
                        
                       

                       

                       
                        <CCol md="3">
                            <CFormLabel  for="inputState">Brand</CFormLabel> 
                           
                             <!-- <Field rules="required" id="inputState" name="group"  /> -->
                             <CFormSelect class=" form-control"  name="name3" id="notificationPreference" v-model="inventory.id_brand"  rules="required" >
                              <option  class="font1">Select Brand</option>
                                
                                
                                 <option  v-for="mbrand in mbrands" :key="mbrand" :value="mbrand.id" class="font1">{{mbrand.brand_name}}</option>
                               
                             </CFormSelect>
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                         </CCol>
                         <CCol md="3">
                            <button type="button" class="btn btn-primary btn11  pt-1 pb-1" data-bs-toggle="modal"  data-bs-target="#exampleModal">+ New Brand</button>
                             
                   
                            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">New Brand</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div class="modal-body">

                                    <CCol md="7">
                                      <CFormLabel for="inputName4">Brand Name</CFormLabel>
                                       <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                                      
          
                                       <Field v-model="brand.brand_name" name="brand" class="form-control " 
                                       />
                                       
                                   
                                      
                                      
                                  </CCol>
                                  </div>
                                  <div class="modal-footer">
                                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                    <button type="button" v-on:click="saveBrand()" class="btn btn-primary">Create</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                        </CCol>
                        <CCol md="3">
                            <CFormLabel  for="inputState">Model</CFormLabel> 
                           
                             <!-- <Field rules="required" id="inputState" name="group"  /> -->
                             <CFormSelect class="form-control "   name="name3" id="notificationPreference"  v-model="inventory.id_model"   rules="required" >
                                 
                                 <option selected class="font1">Select Model</option>
                                
                            <option v-for="mmodel in mmodels" :key="mmodel" :value="mmodel.id" class="font1">{{mmodel.modelname}}</option>
                                 
                             </CFormSelect>
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                         </CCol>
                        <CCol md="3">
                
                            <button type="button" class="btn btn-primary btn11  pt-1 pb-1" data-bs-toggle="modal"  data-bs-target="#exampleModal1">+ New Model</button>
                             
                   
                            <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">New Model</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div class="modal-body">

                                    <CCol md="7">
                                      <CFormLabel for="inputName4">Model Name</CFormLabel>
                                       <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                                      
          
                                       <Field v-model="model.modelname" name="brand" class="form-control "
                                       />
                                   
                                      
                                      
                                  </CCol>
                                  </div>
                                  <div class="modal-footer">
                                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                    <button type="button" v-on:click="saveModel()" class="btn btn-primary">Create</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            
                        </CCol>
                    </div><br>
                    <div class="row ">
                      <CCol md="3">
                        <CFormLabel  for="inputState">Product Code</CFormLabel> 
                       
                         <!-- <Field rules="required" id="inputState" name="group"  /> -->
                         <CFormSelect class=" "  v-model="inventory.I_pcode"  name="name3" id="notificationPreference"   rules="required" >
                             
                             <option class="font1">Select Product</option>
                            
                             <option v-for="mvehicle in mvehicles" :key="mvehicle" :value="mvehicle.idProduct" class="font1">{{mvehicle.P_code}}</option>
                            
                         </CFormSelect>
                         <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                         <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                         </div> -->
                     </CCol>
                        <CCol md="3">
                            <CFormLabel    for="inputName4">Registration No.</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <Field name="Registration" v-model="inventory.reg_no"   class="form-control" 
                             rules="required"  />
                            
                            
                            
                            
                        </CCol>
                        <CCol md="3">
                            <CFormLabel for="inputName4">Engine No.</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <Field name="Engine"   v-model="inventory.eng_no"  class="form-control" 
                             rules="required"  />
                         
                            
                            
                            
                        </CCol>
                        <CCol md="3">
                            <CFormLabel for="inputName4">Chassis No.</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <Field name="Chassis"  v-model="inventory.chassis"  class="form-control" 
                             rules="required"  />
                          
                            
                            
                            
                        </CCol>
                    </div><br>
                    <div class="row ">
                      <CCol md="3">
                        <CFormLabel for="inputName4">Color</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="Color"  v-model="inventory.color"  class="form-control"
                         rules="required"  />
                                                                    
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Interior</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="Interior"  v-model="inventory.interior"   class="form-control" 
                         rules="required"  />
                                                                    
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Seating Capacity</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="seating_capacity"  v-model="inventory.seating_capacity"   class="form-control" 
                         rules="required"  />
                                                                         
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Received Qty</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="received_qty"   class="form-control"  v-model="inventory.received_qty"
                         rules="required"  />
                                                                       
                    </CCol>


                    </div><br>
                    <div class="row ">
                      <CCol md="3">
                        <CFormLabel for="inputName4">image</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="image"    class="form-control"  v-model="inventory.image"
                         rules="required"  />
                                                                       
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Next Service Mileage</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="next_service_mileage" type="number"   class="form-control"  v-model="inventory.next_service_mileage"
                         rules="required"  />
                                                                          
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Last Service Date</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="last_service_date"    class="form-control" v-model="inventory.last_service_date" :class="{ 'is-invalid': errors.last_service_date}"
                         rules="required"  />
                        <span class="clr3 " >{{ errors.last_service_date }}</span>                                                    
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Owner Details</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <textarea class="form-control" v-model="inventory.owner_details" rows="3"></textarea>                                                  
                    </CCol>


                    </div><br>

                    <div class="row">
                      <CCol md="3">
                        <CFormLabel for="inputName4">Remarks</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <textarea v-model="inventory.remarks"  class="form-control"  rows="3"></textarea>                                                  
                    </CCol>
                    </div>

                   

                    
                    
                    
                  
              
               
                   
                    

                   
                    
                    
                    
                    
                    <CCol class="right1 mt-4">
                       
                    
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                        
                            <CButton  color="success" class="btn1" type="submit"> Create</CButton>
                            <router-link class="line1 btn btn-danger " to="/miinventory/index">Cancel</router-link>
                        </div>
                    </CCol>
                </Form>




            </div>
        </div>


       
        
         
           


    </div>
    <!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
    <!-- <form @submit.prevent="del()" class="" >
     <input type="text" v-model="user.id"  class="form-control" >
     <button  type="" class="btn btn-success" >delete</button>
     </form> -->

</template>

<script>
    import {  CCol, CFormLabel, CFormSelect,  CButton, } from '@coreui/vue';
    import { defineRule,Form, Field  } from 'vee-validate';
    //import httpClient from '@/axios';
    import NavView from '../../components/NavView.vue'
    import SideBar from '../../components/SideBar.vue'
    import authService from '@/auth.service';
    import axios from 'axios';
  

   
    defineRule('minMax', (value, [min, max]) => {
  // The field is empty so it should pass
  if (!value || !value.length) {
    return true;
  }
  const numericValue = Number(value.length);
  if (numericValue < min) {
    return 'Please enter a valid phone number.';
  }
  if (numericValue > max) {
    return 'Please enter a valid phone number.';
  }
  return true;
});

    defineRule('required', value => {
     if (!value || !value.length) {
    return 'This field is required';
    }
    return true;
    });

    defineRule('email', value => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if  (!/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/.test(value)) {
    
    return 'Please enter valid email address';
    
  }
  return true;
});



    

    export default {
      mounted(){
  this.load()
    },
        data() {
      
  
        
    
            return {

              access_token:authService.isLoggedIn(),

                isHidden: false,
                count: 0,
                values:{},

                isHidden1: false,
                count1: 0,
                values1:{},
                 
                mbrands:'',
                mmodels:'',
                mvehicles:'',
             
                'brand':{
                'brand_name':'',
                'created_date':'2022-09-25',
                'created_by':'10',
              },

              
            'model':{
              'modelname':'',
              'created_date':'2022-09-25',
              'created_by':'10',
            },


              'inventory':{
                'id_brand':'',
                'id_model':'',
                'I_pcode':'',
                'reg_no':'',
                'eng_no':'',
                'chassis':'',
                'color':'',
                'interior':'',
                'seating_capacity':'',
                'received_qty':'',
                'image':'',
                'next_service_mileage':'',
                'last_service_date':'',
                'owner_details':'',
                'remarks':'',
                'inventory_status':'1',
                'passenger':'5',

               
              }
              
           
              

              
               
            };
        },

        // validation:{
        //     customer: {
        //         name:{
        //             required,
        //             minLength: minLength(2),

        //         }



        //     },


        // },


        components: {
            CCol,Field, CFormLabel,   CButton,Form,NavView,SideBar,CFormSelect
        },

        methods: {

          async saveBrand() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
      console.log(this.access_token);
      console.log(this.brand_name);
      try {
        const { data} = await  axios.post('/web/api/mbrands/create' ,{brand:this.brand},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      } catch (error) {
        console.log(error);
      }
    //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
    //     response => {
    //       console.log(response);
    //      this.item = response.data.success;
    window.location.reload();
          
      //  }
       
       //)
        
   

    },


    async saveModel() {
    // console.log("here we are",this.errorlist); check karaganimata awashya we
    console.log(this.access_token);
    console.log(this.model);
    try {
      const { data} = await  axios.post('/web/api/mmodels/create' ,{model:this.model},{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
    } catch (error) {
      console.log(error);
    }
  //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
  //     response => {
  //       console.log(response);
  //      this.item = response.data.success;
         window.location.reload();
        
    //  }
     
     //)
      
 

  },


          async load() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/web/api/mbrands/ginbrandslist',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mbrands = data.item_list;
      
    } catch (error) {
      console.log(error.response);
    }

    try {
      const { data} = await  axios.get('/web/api/mmodels/ginmodelslist',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mmodels = data.item_list;
      
    } catch (error) {
      console.log(error.response);
    }

    try {
      const { data} = await  axios.get('/web/api/mproduct/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mvehicles = data.item_list;
       
    } catch (error) {
      console.log(error.response);
    }
  },





            async saveData() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
      console.log(this.access_token);
      console.log(this.inventory.id_brand);
      try {
        const { data} = await  axios.post('/web/api/iinventory/create' ,{inventory:this.inventory},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      } catch (error) {
        console.log(error);
      }
    //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
    //     response => {
    //       console.log(response);
    //      this.item = response.data.success;
           //window.location.reload();
          
      //  }
       
       //)
        
   

    },
        
    
            // add(){
            //     this.customer.push({
                    // 'contactname': '',
                    // 'contactdis': '',
                    // 'contactemail': '',
                    // 'contactmobile': '',
            //     })

            // },

//             createNewElement() {
//     // First create a DIV element.
// 	var txtNewInputBox1 = document.createElement('div');
// 	var txtNewInputBox2 = document.createElement('div');
// 	var txtNewInputBox3 = document.createElement('div');
// 	var txtNewInputBox4 = document.createElement('div');

//     // Then add the content (a new input box) of the element.
// 	txtNewInputBox1.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox2.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox3.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox4.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";

//     // Finally put it where it is supposed to appear.
// 	document.getElementById("newElementId1").appendChild(txtNewInputBox1);
//     document.getElementById("newElementId2").appendChild(txtNewInputBox2);
//     document.getElementById("newElementId3").appendChild(txtNewInputBox3);
//     document.getElementById("newElementId4").appendChild(txtNewInputBox4);
// },

 





            // saveData() {
                

            //     console.log("ok");
            //     console.log(this.customer);

                




            // }
        }

    };


</script>

<style scoped>
   .font1{
    font-size: 13px !important;
 
  }
  .font-bold1{
    font-weight: bold;
  }
   
    .clr1 {
        background-color: #D4E1E8;
        padding: 2px;
        padding-left: 20px;
    }

    .clr2 {
        background-color: #AED8F2;
        padding: 2px;
        border-radius: 3px
    }

    .right1 {
        text-align: right;
    }

    .btn1 {
        padding-left: 22px;
        padding-right: 22px;
    }
    .btn11 {
       margin-top: 28px;
       padding-left: 75px;
       padding-right: 75px ;
       
    }

    .clr3 {
        color: red;
    }

    .left1{
        text-align: left;
    }

    .width1{
        width: 25%;
    }
    .width2{
        width: 20%;
    }
    

    .hiden1 {
        display: none;
    }
    .button2{
        margin-left: 5px;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .body1{
    border-top: 1px solid black;
  }
  .group 			  { 
  position:relative; 
  margin-bottom:10px; 
  
  
}
.input3 				{
  font-size:14px;
  padding:10px 10px 3px 5px;
  display:block;
  width:90%;
  border:none;
  border-bottom:2px solid #999;
}
.input3:focus 		{ outline:none; }

/* LABEL ======================================= */
.label1 				 {
  color:#999; 
  font-size:13px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
}

/* active state */
.input3:focus ~ .label1, .input3:valid ~ .label1 		{
  top:-10px;
  font-size:13px;
  color:#999;
}
</style>